// src/state/productEmbeddingStore.js
// Cache product embeddings by productId + sourceHash

const KEY = "veya_product_embeddings_v1";

function safeRead() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
}

function safeWrite(data) {
  try {
    localStorage.setItem(KEY, JSON.stringify(data || {}));
  } catch {}
}

function hashString(str) {
  const s = String(str || "");
  let h = 2166136261;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return (h >>> 0).toString(16);
}

export function computeProductSourceHash(product) {
  const blob = [
    product.name,
    product.category,
    product.variant,
    product.brand,
    ...(product.styleTags || []),
    product.fit,
    product.budgetTier
  ].join("|");

  return hashString(blob);
}

export function getProductEmbedding(productId) {
  const map = safeRead();
  return map[productId] || null;
}

export function setProductEmbedding(productId, entry) {
  const map = safeRead();
  map[productId] = {
    ...entry,
    updatedAt: Date.now(),
  };
  safeWrite(map);
  return map[productId];
}